'use strict';

import Polyglot from 'node-polyglot';
import CommandPalette from '../views/modules/commandPalette.js';
import { onPageLoad } from './pageLoad.js';

if (typeof(window?.deskedGlobals?.i18n) !== 'object')
  throw Error('deskedGlobals.i18n must be defined');

let locale = window.deskedGlobals.i18n.locale;
let phrases = window.deskedGlobals.i18n.phrases;
let weekdaysShort = window.deskedGlobals.i18n.weekdaysShort;

if (!locale || !phrases)
  throw Error('locale and phrases must be defined');

window.deskedGlobals.i18n.polyglot = new Polyglot({
  locale: locale,
  phrases: { ...phrases, weekdaysShort }
})

window.TR = window.deskedGlobals.i18n.polyglot.t.bind(window.deskedGlobals.i18n.polyglot);
window.TR.has = window.deskedGlobals.i18n.polyglot.has.bind(window.deskedGlobals.i18n.polyglot);

// F-15 follow-up: Turbo Drive follows in-page action anchors (href="#!") because
// their *resolved* URL is "/path#!", not a bare "#", so Turbo's LinkClickObserver
// turns the click into a full advance visit + <body> swap mid-interaction. Those
// anchors already do their work in JS handlers; the hash-nav default is unwanted.
// Suppress it once, site-wide, in the capture phase so defaultPrevented is set
// before Turbo's bubble-phase observer sees the click.
document.addEventListener('click', function(e) {
  var a = e.target.closest && e.target.closest('a[href="#!"], a[href="#"]');
  if (a) e.preventDefault();
}, true);

const trClass = 'TR';

window.TR.updateDOM = function() {
  //don't use getElementByClassName as it is a live collection
  for (let e of document.querySelectorAll("."+trClass)) {
    let key = e.textContent.replace(/^\s*|\s*$/g,'').replace(/\s*\n\s*/g,' ');
    e.textContent = window.deskedGlobals.i18n.polyglot.t(key);
    e.classList.remove(trClass);
  }
}

window.TR.translateTooltips = function(container) {
  var scope = container || document;
  for (let e of scope.querySelectorAll('[data-tooltip]')) {
    let key = e.getAttribute('data-tooltip');
    if (key && window.deskedGlobals.i18n.polyglot.has(key)) {
      e.setAttribute('data-tooltip', window.deskedGlobals.i18n.polyglot.t(key));
    }
  }
}

window.TR.inline = function() {
  document.write(
    window.deskedGlobals.i18n.polyglot.t.apply(
      window.deskedGlobals.i18n.polyglot,
      arguments));
}

onPageLoad(function() {
  window.TR.updateDOM();

  // Initialize Materialize components
  var dropdowns = document.querySelectorAll('.dropdown-trigger');
  M.Dropdown.init(dropdowns, {
    constrainWidth: false,
    coverTrigger: false,
    alignment: 'left'
  });

  // Translate data-tooltip attributes and initialize Materialize tooltips
  TR.translateTooltips();
  var tooltips = document.querySelectorAll('.tooltipped');
  if (tooltips.length > 0) {
    M.Tooltip.init(tooltips, { enterDelay: 300, exitDelay: 100 });
  }

  // Command palette (Ctrl+K / Cmd+K)
  CommandPalette.getInstance().init();
});
